// 本人報到
export default {
  methods: {
    RegisterUnitOwner (requestData) {
      console.log(requestData)
      return new Promise((resolve, reject) => {
        apiUnitOwnerAssembly.Register.RegisterUnitOwner(
          requestData
        ).then(res => {
          if (res.status === 200) {
            resolve({ status: res.status })
          }
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
          if (err.response && err.response.status >= 400) {
            resolve({
              status: err.response.status,
              message: err.response.data.description
            })
          }
        })
      })
    }
  }
}
